
const fields = [
    {
      name:'Section A',
      label:'SECTION A: Docket',
      type:'label',
      layout:'col s12 section-title',
      anchorLink:{
        status: true,
        id:'sectionA'
      }
    },
    /*  */
    {
      name:'custom_label_01_label',
      label:'(Ensure that the data in this section is accurate; and please explain in the comments if what is stated in brackets for points 3 and 5 is not the case)',
      type:'label',
      layout:'col description s12',
/*  */
    },
    {
      name:'01_cases_carried_over_term_label',
      label:'1. Number of cases already on the docket carried over from previous term',
      type:'label',
      layout:'col description drag-line',
    },
    {
      name:'01_cases_carried_over_term',
      label:'',
      type:'number',
      values:'',
      readonly:false,
      layout:'col number-value',
    },
    /*  */
    {
      name:'02_cases_carried_over_term_label',
      label:'2. Number of new cases arriving onto the docket during current term',
      type:'label',
      layout:'col description drag-line',
    },
    {
      name:'02_cases_carried_over_term',
      label:'',
      type:'number',
      values:'',
      readonly:false,
      layout:'col number-value',
    },
     /*  */
    {
      name:'03_cases_listed_current_term_label',
      label:'3. Total number of cases on the docket during current term (point 1 plus point 2)',
      type:'label',
      layout:'col description drag-line',
    },
    {
      name:'03_cases_listed_current_term',
      label:'',
      type:'number',
      values:'',
      readonly:false,
      layout:'col number-value',
    },
  /*  */
  {
    name:'04_cases_finished_during_current_term_label',
    label:'4. Number of cases on the docket finished during current term',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'04_cases_finished_during_current_term',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
    /*  */
  {
    name:'05_carried_over_to_next_term_label',
    label:'5. Number of cases carried over to the docket for next term (point 3 minus point 4)',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'05_carried_over_to_next_term',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  /*  */
  {
    name:'Section B',
    label:'SECTION B: NATURE OF CASES LISTED FOR TRIAL',
    type:'label',
    layout:'col s12 section-title',
    anchorLink:{
      status: true,
      id:'sectionB'
    }
  },
  /*  */
  {
    name:'06_cases_involving_children_label',
    label:'6.	Nature of cases on the docket (Example: 4 sexual offences, 3 firearm offences etc)',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'06_cases_involving_children',
    label:'',
    type:'text_area',
    values:'',
    readonly:false,
    layout:'col s12',
  },
  /*  */
  {
    name:'Section C',
    label:'SECTION C: Court Output',
    type:'label',
    layout:'col s12 section-title',
    anchorLink:{
      status: true,
      id:'sectionB'
    }
  },
  /*  */
     /* */
   {
    name:'07_number_of_cases_involving_children_label',
    label:`7. Number of cases involving children (meaning who are under 18) who are the:`,
    type:'label',
    layout:'col s12',
  },
  {
    name:'07_number_of_cases_involving_children',
    label:'',
    type:'data_table',
    header:[' ', 'Total'],
    add_placeholder:'Reason',
    add_button_caption: 'Add Reasons',
    other_label: `<span class="blue-text text-accent-4">State additional reasons</span>`,
    show_total: false,
    //total_option_label: `Total number of trials adjourned (should be same figure in 15)`,
    values:[
      { 
        reason: "Virtual Complaint", 
        total: 0
      },
      { 
        reason: "Defendant", 
        total: 0
      },
      { 
        reason: "Witness", 
        total: 0
      },
     
    ],
    can_add: false,
    readonly:false,
    layout:'col s12',
  },
  {
    name:'08_a_number_of_bail_applications_label',
    label:'8. (a) Number of bail applications ',
    type:'label',
    layout:'col description',
  },
  {
    name:'08_a_number_of_bail_applications',
    label:'',
    type:'data_table',
    header:[' ', 'Total'],
    add_placeholder:'Reason',
    add_button_caption: 'Add Reasons',
    other_label: `<span class="blue-text text-accent-4">State additional reasons</span>`,
    show_total: false,
    //total_option_label: `Total number of trials adjourned (should be same figure in 15)`,
    values:[
      { 
        reason: "Approved", 
        total: 0
      },
      { 
        reason: "Denied", 
        total: 0
      },
      { 
        reason: "Varied", 
        total: 0
      },
     
    ],
    can_add: false,
    readonly:false,
    layout:'col s12  sub-indent',
  },
   {
    name:'08_b_number_of_bail_applications_label',
    label:'(b) Further comments on bail applications (optional)',
    type:'label',
    layout:'col 12 sub-indent',
  },
  {
    name:'08_b_number_of_bail_applications',
    label:'',
    type:'text_area',
    values:'',
    readonly:false,
    layout:'col s12 sub-indent',
  },
  /*  */
  {
    name:'09_number_of_discontinuances_label',
    label:'9.	Number of discontinuances',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'09_number_of_discontinuances',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  /*  */
  {
    name:'10_number_of_pleas_label',
    label:'10.	Number of pleas',
    type:'label',
    layout:'col description drag-line',
  },

    {
    name:'10_number_of_pleas',
    label:'',
    type:'data_table',
    header:[' ', 'Total'],
    add_placeholder:'Reason',
    add_button_caption: 'Add Reasons',
    other_label: `<span class="blue-text text-accent-4">State additional reasons</span>`,
    show_total: false,
    //total_option_label: `Total number of trials adjourned (should be same figure in 15)`,
    values:[
      { 
        reason: "Guilty", 
        total: 0
      },
      { 
        reason: "Not Guilty", 
        total: 0
      }
    ],
    can_add: false,
    readonly:false,
    layout:'col s12',
  },
  /*  */
  {
    name:'11_number_of_completed_sentences_label',
    label:'11. Number of completed sentences',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'11_number_of_completed_sentences',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value ',
  },
  /*  */
 {
    name:'12_number_of_trials_started_label',
    label:'12. Number of trials started',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'12_number_of_trials_started',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  
  /*  */
  {
    name:'13_a_number_of_trials_completed_label',
    label:'13. (a) Number of trials completed',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'13_a_Number_of_trials_completed',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  {
    name:'13_b_how_many_completed_trials_lasted_up_to_label',
    label:'(b) How many completed trials have lasted up to?',
    type:'label',
    layout:'col description sub-indent drag-line',
  },
 
  {
    name:'13_b_how_many_completed_have_trails_lasted_up_to',
    label:'',
    type:'data_table',
    header:[' ', 'Total'],
    add_placeholder:'Reason',
    add_button_caption: 'Add Reasons',
    other_label: `<span class="blue-text text-accent-4">State additional reasons</span>`,
    show_total: false,
    //total_option_label: `Total number of trials adjourned (should be same figure in 15)`,
    values:[
      { 
        reason: "2 days", 
        total: 0
      },
      { 
        reason: "5 days", 
        total: 0
      },
      { 
        reason: "10 days", 
        total: 0
      },
       { 
        reason: "More than 10 days", 
        total: 0
      },
     
    ],
    can_add: false,
    readonly:false,
    layout:'col s12 sub-indent',
  },

  {
    name:'13_c_method_of_completion_of_each_trial_in_13a_label',
    label:'(C) Method of completion of each trial in 13a:',
    type:'label',
    layout:'col description sub-indent drag-line',
  },
 
  {
    name:'13_c_method_of_completion_of_each_trial_in_13a',
    label:'',
    type:'data_table',
    header:['Method of completion/disposal', 'Number'],
    add_placeholder:'Method',
    add_button_caption: 'Add Other methods',
    other_label: `<span class="blue-text text-accent-4">Add other methods(+)</span>`,
    show_total: true,
    total_option_label: `<strong> Total trials completed </strong> (indicate in comments if there were trials with more than
1 method of completion; hence this total would not be the same as that in 13a)`,
    values:[
      { 
        reason: "Trial and oral sentence", 
        total: 0
      },
      { 
        reason: "Trial and written sentence", 
        total: 0
      },
      { 
        reason: "Indictment Stayed", 
        total: 0
      },
      { 
        reason: "Indictment Withdrawn", 
        total: 0
      },
      {
        reason: "Trial completed and defendant acquitted",
        total: 0,
      }
     
    ],
    can_add: true,
    readonly:true,
    layout:'col s12 sub-indent',
  },


  {
    name:'14_a_total_number_of_cases_awaiting_sentence_after_jury_verdict_label',
    label:'14. (a) Total number of cases awaiting sentence after jury verdict',
    type:'label',
    layout:'col description drag-line ',
  },
  {
    name:'14_a_total_number_of_cases_awaiting_sentence_after_jury_verdict',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value ',
  },
  {
    name:'14_b_Number_of_cases_in_14(a)_awaiting_sentencing_for_3_months_or_more_after_jury_verdict_label',
    label:'(b) Number of cases in 14(a) awaiting sentencing for 3 months or more after jury verdict',
    type:'label',
    layout:'col description drag-line sub-indent',
  },
  {
    name:'14_b_Number_of_cases_in_14(a)_awaiting_sentencing_for_3_months_or_more_after_jury_verdict',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  {
    name:'14_c_explanation_label',
    label:'(c) Explanation for 14(b)',
    type:'label',
    layout:'col 12 sub-indent',
  },
  {
    name:'14_c_explanation',
    label:'',
    type:'text_area',
    values:'',
    readonly:false,
    layout:'col s12 sub-indent',
  },
  /*  */
  {
    name:'15_a_total_number_of_cases_awaiting_sentence_after_a_guilty_plea_label',
    label:'15 (a) Total number of cases awaiting sentence after a guilty plea',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'15_a_total_number_of_cases_awaiting_sentence_after_a_guilty_plea',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
    {
    name:'15_b_Number_of_cases_in_15_a_awaiting_sentence_for_3_months_or_more_after_a_guilty_label',
    label:'(b) Number of cases in 15a awaiting sentence for 3 months or more after a guilty plea.',
    type:'label',
    layout:'col description drag-line sub-indent',
  },
  {
    name:'15_b_Number_of_cases_in_15_a_awaiting_sentence_for_3_months_or_more_after_a_guilty',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col  number-value ',
  },
 {
    name:'15_c_explanation_label',
    label:'(c) Explanation for 15(b)',
    type:'label',
    layout:'col s12 sub-indent',
  },
  {
    name:'15_c_explanation',
    label:'',
    type:'text_area',
    values:'',
    readonly:false,
    layout:'col s12 sub-indent',
  },
  /* */
  {
    name:'16_number_of_cases_given_trial_date_listings_label',
    label:'16 (a) Number of cases given trial date listings.',
    type:'label',
    layout:'col s12 description ',
  },
  {
    name:'16_number_of_cases_given_trial_date_listings',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  {
    name:'16_b_number_of_cases_given_trial_date_listings_and_were_tried_on_the_first_set_date_label',
    label:'(b) Number of cases given trial date listings and were tried on the first set date.',
    type:'label',
    layout:'col s12 description sub-indent',
  },
  {
    name:'16_b_number_of_cases_given_trial_date_listings_and_were_tried_on_the_first_set_date',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },

   {
    name:'16_c_number_of_cases_give_trial_date_listings_never_given_label',
    label:'(c) Number of cases given trial date listings but were adjourned and given new trial dates (before being tried):',
    type:'label',
    layout:'col description sub-indent drag-line',
  },
 
  {
    name:'16_c_number_of_cases_give_trial_date_listings_never_given',
    label:'',
    type:'data_table',
    header:[' ', 'Total'],
    add_placeholder:'Method',
    add_button_caption: 'Add Other methods',
    other_label: `<span class="blue-text text-accent-4">Add other methods(+)</span>`,
    show_total: false,
    total_option_label: `<strong> Total trials completed </strong>`,
    values:[
      { 
        reason: "Once", 
        total: 0
      },
      { 
        reason: "2 Times", 
        total: 0
      },
      { 
        reason: "3 Times", 
        total: 0
      },
      { 
        reason: "4 Times", 
        total: 0
      },
      {
        reason: "More than 4 Times",
        total: 0,
      }
     
    ],
    can_add: false,
    readonly:false,
    layout:'col s12 sub-indent',
  },

   /* */
   {
    name:'16_d_reasons_for_adjournments_label',
    label:`(d) Reasons for adjournments of the trials in part (c):`,
    type:'label',
    layout:'col s12 sub-indent',
  },

   {
    name:'16_d_reasons_for_adjournments_label',
    label:'',
    type:'data_table',
    header:['Reason', 'Total'],
    add_placeholder:'Reason',
    add_button_caption: 'Add Other reasons',
    other_label: `<span class="blue-text text-accent-4">Add other methods(+)</span>`,
    show_total: false,
    total_option_label: ``,
    values:[
      { 
        reason: "To obtain legal representation", 
        total: 0
      },
      { 
        reason: "For plea discussion", 
        total: 0
      },
      { 
        reason: "Due to absence of attorney", 
        total: 0
      },
      { 
        reason: "Due to absence of witnesses", 
        total: 0
      },
      {
        reason: "Due to another trial taking priority",
        total: 0,
      },
      {
        reason: "Due to disclosure",
        total: 0,
      },
      {
        reason: "Due to lack of preparation by counsel",
        total: 0,
      },
      {
        reason: "For further case management",
        total: 0,
      }
     
    ],
    can_add: true,
    readonly:true,
    layout:'col s12 sub-indent',
  },

    /*  */
    {
      name:'17_a_how_many_cases_on_the_document_are_retrials_awaiting_transcripts_label',
      label:'17. (a) How many cases on the docket are retrials awaiting transcripts?',
      type:'label',
      layout:'col description',
    },
    {
      name:'17_a_how_many_cases_on_the_document_are_retrials_awaiting_transcripts',
      label:'',
      type:'number',
      values:'',
      readonly:false,
      layout:'col number-value',
    },
    
    {
      name:'17_b_what_year_and_month_was_each_original_trial_label',
      label:'(b) What year and month was each original trial:',
      type:'label',
      layout:'col description sub-indent',
    },
    {
      name:'17_b_what_year_and_month_was_each_original_trial',
      label:'',
      type:'text_area',
      values:'',
      readonly:false,
      layout:'col s12',
    },

  /*  */
  {
    name:'18_how_many_trials_have_not_been_completed_owing_to_there_being_a_hung_jury_label',
    label:'18. How many trials have not been completed owing to there being a hung jury?',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'18_how_many_trials_have_not_been_completed_owing_to_there_being_a_hung_jury',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value ',
},
  /* 17 18 */
  /*  */
  {
    name:'19_How_many_trials_have_not_been_completed_owing_to_the_jury_being_discharged_label',
    label:'19. How many trials have not been completed owing to the jury being discharged?',
    type:'label',
    layout:'col description',
  },
  {
    name:'19_How_many_trials_have_not_been_completed_owing_to_the_jury_being_discharged',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  /*  */
  {
    name:'20_what_were_the_reasons_for_discharge_label',
    label:'20. What were the reasons for discharge',
    type:'label',
    layout:'col description',
  },
  {
    name:'20_what_were_the_reasons_for_discharge',
    label:'',
    type:'text_area',
    values:'',
    readonly:false,
    layout:'col s12',
  },
  {
    name:'21_How_many_trials_have_been_by_judge_alone_label',
    label:'21. How many trials have been by judge - alone?',
    type:'label',
    layout:'col description',
  },
  {
    name:'21_How_many_trials_have_been_by_judge_alone',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  {
    name:'22_how_many_trials_evolved_into_judge_alone_trials_because_of_a_jury_being_discharged_label',
    label:'22 How many trials evolved into judge - alone trials because of a jury being discharged?',
    type:'label',
    layout:'col description',
  },
  {
    name:'22_how_many_trials_evolved_into_judge_alone_trials_because_of_a_jury_being_discharged',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  {
    name:'23_how_many_retrials_have_been_judge_alone_trials_owing_to_the_jury_being_hung_in_a_previous_trial_label',
    label:'23. How many retrials have been judge - alone trials owing to the jury being hung in a previous trial?',
    type:'label',
    layout:'col description',
  },
  {
    name:'23_how_many_retrials_have_been_judge_alone_trials_owing_to_the_jury_being_hung_in_a_previous_trial',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  { 
    name:'24_how_many_written_verdicts_by_the_judge_alone_are_outstanding_label',
    label:'24. How many written verdicts by the judge alone are outstanding?',
    type:'label',
    layout:'col description',
  },
  {
    name:'24_how_many_written_verdicts_by_the_judge_alone_are_outstanding',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
   {
    name:'25_how_many_judge_alone_trials_have_lasted_up_to_label',
    label:'25. How many judge - alone trials have lasted up to?',
    type:'label',
    layout:'col description drag-line',
  },
 
  {
    name:'25_how_many_judge_alone_trials_have_lasted_up_to',
    label:'',
    type:'data_table',
    header:[' ', 'Total'],
    add_placeholder:'Reason',
    add_button_caption: 'Add Reasons',
    other_label: `<span class="blue-text text-accent-4">State additional reasons</span>`,
    show_total: false,
    //total_option_label: `Total number of trials adjourned (should be same figure in 15)`,
    values:[
      { 
        reason: "2 days", 
        total: 0
      },
      { 
        reason: "5 days", 
        total: 0
      },
      { 
        reason: "10 days", 
        total: 0
      },
       { 
        reason: "More than 10 days", 
        total: 0
      },
     
    ],
    can_add: false,
    readonly:false,
    layout:'col s12 ',
  },
  /*  */
  {
    name:'Section D',
    label:'SECTION D: Rulings',
    type:'label',
    layout:'col s12 section-title',
    anchorLink:{
      status: true,
      id:'sectionD'
    }
  },
  /*  */
  {
    name:'26_Number_of_oral_rulings_on_points_of_law_delivered_label',
    label:'26. Number of oral rulings on points of law delivered',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'26_Number_of_oral_rulings_on_points_of_law_delivered',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },

  {
    name:'27_Number_of_written_rulings_on_points_of_law_delivered_label',
    label:'27. Number of written rulings on points of law delivered',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'27_Number_of_written_rulings_on_points_of_law_delivered',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },

  
  {
    name:'28_Number_of_written_rulings_on_points_of_law_outstanding_label',
    label:'28. Number of written rulings on points of law outstanding',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'28_Number_of_written_rulings_on_points_of_law_outstanding',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
    /*  */
  
  /*  */
  {
    name:'Section E',
    label:'SECTION E: REMAND (as at the end of the Term being reported)',
    type:'label',
    layout:'col s12 section-title',
    anchorLink:{
      status: true,
      id:'sectionE'
    }
  },
  /*  */
  {
    name:'29_Number_of_persons_on_remand_in_the_terms_docket_label',
    label:`29. Number of persons on remand (pending trial/sentence/retrial) in the term's docket`,
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'29_Number_of_persons_on_remand_in_the_terms_docket',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },


  {
    name:'30_Number_of_persons_on_remand_for_label',
    label:`30. Number of persons on remand for:`,
    type:'label',
    layout:'col description ',
  },

  {
    name:'30_Number_of_persons_on_remand_for',
    label:'',
    type:'data_table',
    header:[' ', 'Total'],
    add_placeholder:'Reason',
    add_button_caption: 'Add Reasons',
    other_label: `<span class="blue-text text-accent-4">State additional reasons</span>`,
    show_total: false,
    //total_option_label: `Total number of trials adjourned (should be same figure in 15)`,
    values:[
      { 
        reason: "Less than 2 years", 
        total: 0
      },
      { 
        reason: "2 years", 
        total: 0
      },
      { 
        reason: "3 years", 
        total: 0
      },
      { 
        reason: "4 years", 
        total: 0
      },
      {  
        reason: "5 years", 
        total: 0
      },
      
      {  
        reason: "6 years", 
        total: 0
      },
      
      {  
        reason: "7 years", 
        total: 0
      },
        {  
        reason: "More than 7 years", 
        total: 0
      },
    ],
    can_add: false,
    readonly:false,
    layout:'col s12 ',
  },

  {
    name:'31_Reasons_why_each_person_on_remand_for_3_years_or_more_has_not_yet_been_tried_label',
    label:`31. Reasons why each person on remand for 3 years or more has not yet been tried:`,
    type:'label',
    layout:'col description',
  },
  {
    name:'31_Reasons_why_each_person_on_remand_for_3_years_or_more_has_not_yet_been_tried',
    label:'',
    type:'text_area',
    values:'',
    readonly:false,
    layout:'col s12 ',
  },
  {
    name:'Section F',
    label:'SECTION F: COMMENTS (please use this section to clarify the data or state additional information)',
    type:'label',
    layout:'col s12 section-title',
    anchorLink:{
      status: true,
      id:'sectionF'
    }
  },
  {
    name:'32_comments',
    label:'',
    type:'text_area',
    values:'',
    readonly:false,
    layout:'col s12 ',
  },
  //end of record
]

const generate = () =>{
  return JSON.parse(JSON.stringify(fields)) 
}

const populate = (data) => {
fields.forEach(item => {
  let key = item.name
  let v = data[key]
  
  if (item.dataType === 'Object'){
    v = item.options.find(a => a.prop === v)
  }
   if(data[key]) {
    item.values = v
  }
})

return fields
}


const populateX = (data) => {

let y = fields.map(item => {
  let x = {...item}
  x.values =  data[item.name]
  return x
})
return y
}
const exportSchema = {
    "01_cases_carried_over_term": {
        "label": "1. Number of cases already on the docket carried over from previous term",
        "key": "01_cases_carried_over_term"
    },
    "02_cases_carried_over_term": {
        "label": "2. Number of new cases arriving onto the docket during current term",
        "key": "02_cases_carried_over_term"
    },
    "03_cases_listed_current_term": {
        "label": "3. Total number of cases on the docket during current term (point 1 plus point 2)",
        "key": "03_cases_listed_current_term"
    },
    "04_cases_finished_during_current_term": {
        "label": "4. Number of cases on the docket finished during current term",
        "key": "04_cases_finished_during_current_term"
    },
    "05_carried_over_to_next_term": {
        "label": "5. Number of cases carried over to the docket for next term (point 3 minus point 4)",
        "key": "05_carried_over_to_next_term"
    },
    "06_cases_involving_children": {
        "label": "6. Nature of cases on the docket (Example: 4 sexual offences, 3 firearm offences etc)",
        "key": "06_cases_involving_children"
    },
    "07_number_of_cases_involving_children": {
        "label": "7. Number of cases involving children (meaning who are under 18) who are the:",
        "key": "07_number_of_cases_involving_children"
    },
    "08_a_number_of_bail_applications": {
        "label": "8. (a) Number of bail applications",
        "key": "08_number_of_bail_applications"
    },
    "08_b_number_of_bail_applications": {
        "label": "8. (b) Further comments on bail applications (optional)",
        "key": "08_b_number_of_bail_applications"
    },
    "09_number_of_discontinuances": {
        "label": "9. Number of discontinuances",
        "key": "09_number_of_discontinuances"
    },
    "10_number_of_pleas": {
        "label": "10. Number of pleas",
        "key": "10_number_of_pleas"
    },
    "11_number_of_completed_sentences": {
        "label": "11. Number of completed sentences",
        "key": "11_number_of_completed_sentences"
    },
    "12_number_of_trials_started": {
        "label": "12. Number of trials started",
        "key": "12_number_of_trials_started"
    },
    "13_a_Number_of_trials_completed": {
        "label": "13. (a) Number of Trials completed",
        "key": "13_a_Number_of_trials_completed"
    },
    "13_b_how_many_completed_have_trails_lasted_up_to": {
        "label": "13. (b) How many completed have trials lasted up to",
        "key": "13_b_how_many_completed_have_trails_lasted_up_to"
    },
    "13_c_method_of_completion_of_each_trial_in_13a": {
        "label": "13 (c) Method of completion of each trial in 13a:",
        "key": "13_c_method_of_completion_of_each_trial_in_13a"
    },
    "14_a_total_number_of_cases_awaiting_sentence_after_jury_verdict": {
        "label": "14. (a) Total number of cases awaiting sentence after jury verdict",
        "key": "14_a_total_number_of_cases_awaiting_sentence_after_jury_verdict"
    },
    "14_b_Number_of_cases_in_14(a)_awaiting_sentencing_for_3_months_or_more_after_jury_verdict": {
        "label": "14. (b) Number of cases in 14(a) awaiting sentencing for 3 months or more after jury verdict",
        "key": "14_b_Number_of_cases_in_14(a)_awaiting_sentencing_for_3_months_or_more_after_jury_verdict"
    },
    "14_c_explanation": {
        "label": "14. (c) Explanation for 14(b)",
        "key": "14_c_explanation"
    },
    "15_a_total_number_of_cases_awaiting_sentence_after_a_guilty_plea": {
        "label": "15. (a) Total number of cases awaiting sentence after a guilty plea",
        "key": "15_a_total_number_of_cases_awaiting_sentence_after_a_guilty_plea"
    },
    "15_b_Number_of_cases_in_15_a_awaiting_sentence_for_3_months_or_more_after_a_guilty": {
        "label": "15. (b) Number of cases in 15a awaiting sentence for 3 months or more after a guilty plea.",
        "key": "15_b_Number_of_cases_in_15_a_awaiting_sentence_for_3_months_or_more_after_a_guilty"
    },
    "15_c_explanation": {
        "label": "15. (c) Explanation for 15(b)",
        "key": "15_c_explanation"
    },
    "16_number_of_cases_given_trial_date_listings": {
        "label": "16. (a) Number of cases given trial date listings.",
        "key": "16_number_of_cases_given_trial_date_listings"
    },
    "16_b_number_of_cases_given_trial_date_listings_and_were_tried_on_the_first_set_date": {
        "label": "16. (b) Number of cases given trial date listings and were tried on the first set date.",
        "key": "16_b_number_of_cases_given_trial_date_listings_and_were_tried_on_the_first_set_date"
    },
    "16_c_number_of_cases_give_trial_date_listings_never_given": {
        "label": "16. (c) Number of cases given trial date listings but were adjourned and given new trial dates (before being tried):",
        "key": "16_c_number_of_cases_give_trial_date_listings_never_given"
    },
    "16_d_reasons_for_adjournments_label": {
        "label": "16. (d) Reasons for Adjournments",
        "key": "16_d_reasons_for_adjournments_label"
    },
    "17_a_how_many_cases_on_the_document_are_retrials_awaiting_transcripts": {
        "label": "17. (a) How many cases on the docket are retrials awaiting transcripts?",
        "key": "17_a_how_many_cases_on_the_document_are_retrials_awaiting_transcripts"
    },
    "17_b_what_year_and_month_was_each_original_trial": {
        "label": "17. (b) What year and month was each original trial:",
        "key": "17_b_what_year_and_month_was_each_original_trial"
    },
    "18_how_many_trials_have_not_been_completed_owing_to_there_being_a_hung_jury": {
        "label": "18. How many trials have not been completed owing to there being a hung jury?",
        "key": "18_how_many_trials_have_not_been_completed_owing_to_there_being_a_hung_jury"
    },
    "19_How_many_trials_have_not_been_completed_owing_to_the_jury_being_discharged": {
        "label": "19. How many trials have not been completed owing to the jury being discharged?",
        "key": "19_How_many_trials_have_not_been_completed_owing_to_the_jury_being_discharged"
    },
    "20_what_were_the_reasons_for_discharge": {
        "label": "20. What were the reasons for discharge",
        "key": "20_what_were_the_reasons_for_discharge"
    },
    "21_How_many_trials_have_been_by_judge_alone": {
        "label": "21. How many trials have been by judge - alone?",
        "key": "21_How_many_trials_have_been_by_judge_alone"
    },
    "22_how_many_trials_evolved_into_judge_alone_trials_because_of_a_jury_being_discharged": {
        "label": "22. How many trials evolved into judge - alone trials because of a jury being discharged?",
        "key": "22_how_many_trials_evolved_into_judge_alone_trials_because_of_a_jury_being_discharged"
    },
    "23_how_many_retrials_have_been_judge_alone_trials_owing_to_the_jury_being_hung_in_a_previous_trial": {
        "label": "23. How many retrials have been judge - alone trials owing to the jury being hung in a previous trial?",
        "key": "23_how_many_retrials_have_been_judge_alone_trials_owing_to_the_jury_being_hung_in_a_previous_trial"
    },
    "24_how_many_written_verdicts_by_the_judge_alone_are_outstanding": {
        "label": "24. How many written verdicts by the judge alone are outstanding?",
        "key": "24_how_many_written_verdicts_by_the_judge_alone_are_outstanding"
    },
    "25_how_many_judge_alone_trials_have_lasted_up_to": {
        "label": "25. How many judge - alone trials have lasted up to?",
        "key": "25_how_many_judge_alone_trials_have_lasted_up_to"
    },
    "26_Number_of_oral_rulings_on_points_of_law_delivered": {
        "label": "26. Number of oral rulings on points of law delivered",
        "key": "26_Number_of_oral_rulings_on_points_of_law_delivered"
    },
    "27_Number_of_written_rulings_on_points_of_law_delivered": {
        "label": "27. Number of written rulings on points of law delivered",
        "key": "27_Number_of_written_rulings_on_points_of_law_delivered"
    },
    "28_Number_of_written_rulings_on_points_of_law_outstanding": {
        "label": "28. Number of written rulings on points of law outstanding",
        "key": "28_Number_of_written_rulings_on_points_of_law_outstanding"
    },
    "29_Number_of_persons_on_remand_in_the_terms_docket": {
        "label": "29. Number of persons on remand (pending trial/sentence/retrial) in the term's docket",
        "key": "29_Number_of_persons_on_remand_in_the_terms_docket"
    },
    "30_Number_of_persons_on_remand_for": {
        "label": "30. Number of persons on remand for:",
        "key": "30_Number_of_persons_on_remand_for"
    },
    "31_Reasons_why_each_person_on_remand_for_3_years_or_more_has_not_yet_been_tried": {
        "label": "31. Reasons why each person on remand for 3 years or more has not yet been tried:",
        "key": "31_Reasons_why_each_person_on_remand_for_3_years_or_more_has_not_yet_been_tried"
    },
    "32_comments": {
        "label": "32 Comments",
        "key": "32_comments"
    }
}
export default {
fields, generate, populate, populateX, exportSchema
}